// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubCategorySection_wrapper__1SKSF","extra-bottom-component":"SubCategorySection_extra-bottom-component__3SdZX"};